<template>
  <div class="alice-rows-header">
    <div>Title</div>
    <div>Client</div>
    <div>Status</div>
    <div>Owner</div>
    <div>Created</div>
    <div></div>
  </div>
</template>

<script>
export default { name: "AliceProjectRowsHeader" };
</script>

<style scoped>
.alice-rows-header {
  display: grid;
  grid-template-columns: minmax(0, 2.4fr) 200px 140px 120px 130px 50px;
  gap: 16px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--border-hairline);
  background: var(--bg-muted);
  position: sticky;
  top: 0;
  z-index: 1;
  font-family: var(--font-ui);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fg-3);
}

@media (max-width: 1279px) {
  .alice-rows-header {
    grid-template-columns: minmax(0, 2.4fr) 140px 120px 50px;
  }
  .alice-rows-header > div:nth-child(2),
  .alice-rows-header > div:nth-child(5) {
    display: none;
  }
}
</style>
